import styled from 'styled-components';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AnchorContainer = styled.div`
  display: flex;
  align-items: start;
  margin-bottom: 24px;
`;

export const LoadingContainer = styled.div`
  position: relative;
  left: 40px;
  top: 10px;
  
  svg {
    width: 28px;
    height: 25px;
  }
`;
